import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ms-detail ms-detail--wide" }
const _hoisted_2 = { class: "d-flex align-start ga-4 mb-2" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "d-flex align-center ga-2 text-caption text-medium-emphasis mt-1" }
const _hoisted_5 = { class: "text-uppercase" }
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-4"
}
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-end mb-3"
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex align-center flex-wrap ga-2 text-body-1 text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_WorkflowGraphView = _resolveComponent("WorkflowGraphView")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_EditorBlock = _resolveComponent("EditorBlock")!
  const _component_WorkflowPayloadEditor = _resolveComponent("WorkflowPayloadEditor")!
  const _component_WorkflowFlow = _resolveComponent("WorkflowFlow")!
  const _component_FactorySteps = _resolveComponent("FactorySteps")!
  const _component_ChipSelect = _resolveComponent("ChipSelect")!
  const _component_ConcurrencySlider = _resolveComponent("ConcurrencySlider")!
  const _component_WhenEditor = _resolveComponent("WhenEditor")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_WorkflowRunBrowser = _resolveComponent("WorkflowRunBrowser")!
  const _component_FactoryRunBrowser = _resolveComponent("FactoryRunBrowser")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      variant: "text",
      size: "small",
      "prepend-icon": "mdi-chevron-left",
      color: "medium-emphasis",
      class: "mb-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
    }, {
      default: _withCtx(() => _cache[23] || (_cache[23] = [
        _createTextVNode(" All automations ")
      ])),
      _: 1,
      __: [23]
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_avatar, {
        color: "primary",
        variant: "tonal",
        rounded: "lg",
        size: "50",
        class: "mt-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: _ctx.meta.icon
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_text_field, {
          "model-value": _ctx.model.name,
          variant: "plain",
          density: "compact",
          "hide-details": "",
          class: "text-h4 font-weight-bold",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.patchText({ name: v })),
          onBlur: _ctx.flushTextSave
        }, null, 8, ["model-value", "onBlur"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.meta.label), 1),
          _cache[24] || (_cache[24] = _createElementVNode("span", null, "·", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.whenLabel), 1)
        ])
      ]),
      (_ctx.model.type !== 'schedule')
        ? (_openBlock(), _createBlock(_component_v_chip, {
            key: 0,
            color: _ctx.model.status === 'active' ? 'success' : 'grey',
            variant: "tonal",
            class: "mr-2",
            onClick: _ctx.toggleStatus
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                icon: _ctx.model.status === 'active' ? 'mdi-circle' : 'mdi-circle-outline',
                size: "x-small"
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.model.status === 'active' ? 'Active' : 'Paused'), 1)
            ]),
            _: 1
          }, 8, ["color", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.model.type === 'schedule')
        ? (_openBlock(), _createBlock(_component_v_switch, {
            key: 1,
            "model-value": _ctx.model.status === 'active',
            color: "primary",
            density: "compact",
            "hide-details": "",
            class: "flex-grow-0 mr-4",
            label: _ctx.model.status === 'active' ? 'Enabled' : 'Disabled',
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => _ctx.patchDiscrete({ status: v ? 'active' : 'paused' }))
          }, null, 8, ["model-value", "label"]))
        : _createCommentVNode("", true),
      (_ctx.model.type !== 'schedule')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            color: "primary",
            variant: "tonal",
            "prepend-icon": "mdi-play",
            loading: _ctx.running,
            class: "mr-2",
            onClick: _ctx.onRunClick
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode(" Run ")
            ])),
            _: 1,
            __: [25]
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.model.type === 'schedule')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 3,
            color: "primary",
            "prepend-icon": "mdi-content-save",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save', _ctx.model)))
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode(" Save ")
            ])),
            _: 1,
            __: [26]
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.model.type !== 'schedule')
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Changes here edit the real " + _toDisplayString(_ctx.model.type) + " and save automatically. Run starts it; progress and past runs live in the Runs tab. ", 1))
      : _createCommentVNode("", true),
    (_ctx.model.type !== 'schedule')
      ? (_openBlock(), _createBlock(_component_v_tabs, {
          key: 1,
          modelValue: _ctx.view,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.view) = $event)),
          color: "primary",
          density: "comfortable",
          class: "mb-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, {
              value: "setup",
              "prepend-icon": "mdi-pencil-outline"
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("Set up")
              ])),
              _: 1,
              __: [27]
            }),
            _createVNode(_component_v_tab, {
              value: "runs",
              "prepend-icon": "mdi-play-circle-outline"
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createTextVNode("Runs")
              ])),
              _: 1,
              __: [28]
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_window, {
      modelValue: _ctx.view,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.view) = $event)),
      touch: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "setup" }, {
          default: _withCtx(() => [
            _createVNode(_component_EditorBlock, {
              n: "1",
              title: "What it does",
              hint: "Tell it the goal in plain language. This is the instruction the lead assistant follows."
            }, {
              default: _withCtx(() => [
                (_ctx.model.type === 'workflow' && _ctx.graph)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_v_btn_toggle, {
                        "model-value": _ctx.goalView,
                        mandatory: "",
                        density: "compact",
                        variant: "outlined",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.goalView = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            value: "text",
                            "prepend-icon": "mdi-text-box-outline"
                          }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode("Text")
                            ])),
                            _: 1,
                            __: [29]
                          }),
                          _createVNode(_component_v_btn, {
                            value: "visual",
                            "prepend-icon": "mdi-graph"
                          }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("Visual")
                            ])),
                            _: 1,
                            __: [30]
                          })
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.goalView === 'visual' && _ctx.model.type === 'workflow' && _ctx.graph)
                  ? (_openBlock(), _createBlock(_component_WorkflowGraphView, {
                      key: 1,
                      nodes: _ctx.graph.nodes,
                      edges: _ctx.graph.edges
                    }, null, 8, ["nodes", "edges"]))
                  : (_openBlock(), _createBlock(_component_v_textarea, {
                      key: 2,
                      "model-value": _ctx.model.job,
                      variant: "outlined",
                      rows: "3",
                      "auto-grow": "",
                      "hide-details": "",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = (v) => _ctx.patchText({ job: v })),
                      onBlur: _ctx.flushTextSave
                    }, null, 8, ["model-value", "onBlur"]))
              ]),
              _: 1
            }),
            (_ctx.model.type !== 'schedule')
              ? (_openBlock(), _createBlock(_component_EditorBlock, {
                  key: 0,
                  n: "2",
                  title: "What it works with",
                  hint: _ctx.inputsHint
                }, {
                  default: _withCtx(() => [
                    (_ctx.model.type === 'workflow')
                      ? (_openBlock(), _createBlock(_component_WorkflowPayloadEditor, {
                          key: 0,
                          "model-value": _ctx.model.dataPayload || '{}',
                          "onUpdate:modelValue": _ctx.onPayload
                        }, null, 8, ["model-value", "onUpdate:modelValue"]))
                      : (_openBlock(), _createBlock(_component_v_textarea, {
                          key: 1,
                          "model-value": _ctx.model.carryPayload ?? 'execute',
                          variant: "outlined",
                          density: "compact",
                          rows: "2",
                          "auto-grow": "",
                          "hide-details": "",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = (v) => _ctx.patch({ carryPayload: v }))
                        }, null, 8, ["model-value"]))
                  ]),
                  _: 1
                }, 8, ["hint"]))
              : _createCommentVNode("", true),
            _createVNode(_component_EditorBlock, {
              n: _ctx.model.type === 'schedule' ? '2' : '3',
              title: "How it works",
              hint: _ctx.howHint
            }, {
              default: _withCtx(() => [
                (_ctx.model.type === 'workflow')
                  ? (_openBlock(), _createBlock(_component_WorkflowFlow, {
                      key: 0,
                      helpers: _ctx.model.helpers,
                      lead: _ctx.model.lead,
                      agents: _ctx.agents,
                      inputs: _ctx.model.inputs,
                      "onUpdate:helpers": _cache[8] || (_cache[8] = (v) => _ctx.patchDiscrete({ helpers: v })),
                      "onUpdate:lead": _cache[9] || (_cache[9] = (v) => _ctx.patchDiscrete({ lead: v })),
                      onEditHelper: _ctx.onHelperIntent,
                      onRemoveHelper: _ctx.onHelperIntent,
                      onAddHelper: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('add-helper', _ctx.model)))
                    }, null, 8, ["helpers", "lead", "agents", "inputs", "onEditHelper", "onRemoveHelper"]))
                  : (_ctx.model.type === 'factory')
                    ? (_openBlock(), _createBlock(_component_FactorySteps, {
                        key: 1,
                        steps: _ctx.model.steps,
                        agents: _ctx.agents,
                        workflows: _ctx.workflows,
                        "onUpdate:steps": _cache[11] || (_cache[11] = (v) => _ctx.patchDiscrete({ steps: v }))
                      }, null, 8, ["steps", "agents", "workflows"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_ChipSelect, {
                          "model-value": _ctx.model.lead,
                          options: _ctx.agentOptions(_ctx.model.lead),
                          icon: "mdi-robot",
                          accent: "",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = (v) => _ctx.patchDiscrete({ lead: v }))
                        }, null, 8, ["model-value", "options"]),
                        _cache[31] || (_cache[31] = _createElementVNode("span", null, "runs the job and emails you the result.", -1))
                      ])),
                (_ctx.model.type === 'workflow')
                  ? (_openBlock(), _createBlock(_component_ConcurrencySlider, {
                      key: 3,
                      label: "Helpers working at once",
                      tooltip: "How many helpers can work at the same time.",
                      "model-value": _ctx.model.concurrency ?? 1,
                      class: "mt-4",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = (v) => _ctx.patchDiscrete({ concurrency: v }))
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["n", "hint"]),
            (_ctx.model.type !== 'workflow')
              ? (_openBlock(), _createBlock(_component_EditorBlock, {
                  key: 1,
                  n: _ctx.model.type === 'schedule' ? '3' : '4',
                  title: "When it runs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_WhenEditor, {
                      type: _ctx.model.type,
                      when: _ctx.model.when,
                      "onUpdate:when": _cache[14] || (_cache[14] = (v) => _ctx.patchDiscrete({ when: v }))
                    }, null, 8, ["type", "when"])
                  ]),
                  _: 1
                }, 8, ["n"]))
              : _createCommentVNode("", true),
            _createVNode(_component_EditorBlock, {
              title: "Delete",
              hint: `Removes this ${_ctx.meta.label.toLowerCase()} for good — it disappears from Advanced too.`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "tonal",
                  "prepend-icon": "mdi-trash-can-outline",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmDelete = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Delete this " + _toDisplayString(_ctx.meta.label.toLowerCase()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["hint"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "runs" }, {
          default: _withCtx(() => [
            (_ctx.model.type !== 'schedule' && _ctx.runState)
              ? (_openBlock(), _createBlock(_component_EditorBlock, {
                  key: 0,
                  title: "Runs",
                  hint: "Live progress and past runs — the same view as Advanced."
                }, {
                  default: _withCtx(() => [
                    (_ctx.model.type === 'workflow')
                      ? (_openBlock(), _createBlock(_component_WorkflowRunBrowser, {
                          key: 0,
                          "workflow-id": _ctx.model.id,
                          "workflow-name": _ctx.model.name,
                          "live-run-state": _ctx.runState,
                          onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('cancel-run', _ctx.model)))
                        }, null, 8, ["workflow-id", "workflow-name", "live-run-state"]))
                      : (_openBlock(), _createBlock(_component_FactoryRunBrowser, {
                          key: 1,
                          "factory-id": _ctx.model.id,
                          "factory-name": _ctx.model.name,
                          "live-run-state": _ctx.runState,
                          onPause: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('pause-run', _ctx.model))),
                          onResume: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('resume-run', _ctx.model))),
                          onCancel: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('cancel-run', _ctx.model)))
                        }, null, 8, ["factory-id", "factory-name", "live-run-state"]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ConfirmationDialog, {
      modelValue: _ctx.confirmDelete,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.confirmDelete) = $event)),
      title: "Delete automation?",
      message: `This deletes the real ${_ctx.model.type} — it disappears from Advanced too.`,
      "item-name": _ctx.model.name,
      "item-type": _ctx.meta.label,
      onConfirm: _ctx.onDeleteConfirm,
      onCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.confirmDelete = false))
    }, null, 8, ["modelValue", "message", "item-name", "item-type", "onConfirm"])
  ]))
}